/* Thành phần HANA Mint · theo Hybrid-Kit.dc.html (UI kit) + luật CLAUDE.md (nút chủ chốt = Cargo Ink).
   Màu chỉ qua var(--…) trong tokens.css. Hover chỉ trong @media (hover: hover). */

/* ───────── Nút ───────── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 12px;
  font: inherit;
  font-weight: var(--fw-label);
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: background 160ms, color 160ms, box-shadow 160ms;
}
.btn svg { flex-shrink: 0; }
.sm { height: 34px; padding: 0 12px; border-radius: 10px; }
.iconOnly { width: 40px; padding: 0; }
.sm.iconOnly { width: 34px; }
.primary { background: var(--btn); color: var(--btn-tx); }
.secondary { background: var(--card); color: var(--tx); box-shadow: inset 0 0 0 1px var(--bd); }
.ghost { background: transparent; color: var(--tx2); }
.soft { background: var(--ctl); color: var(--tx); }
.ask { background: var(--pri-bg); color: var(--link); }
.danger { background: var(--danger); color: var(--on-color); }
.btn:disabled,
.btn[aria-disabled='true'] { background: var(--ctl); color: var(--lb); box-shadow: none; cursor: not-allowed; }
.btn[aria-busy='true'] { cursor: progress; }
.spin { animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

@media (hover: hover) {
  .primary:not(:disabled):hover { background: var(--btn-hov); }
  .secondary:not(:disabled):hover { background: var(--sub); }
  .ghost:not(:disabled):hover { background: var(--ctl); color: var(--tx); }
  .soft:not(:disabled):hover { background: var(--bd); }
  .ask:not(:disabled):hover { box-shadow: inset 0 0 0 1px var(--pri-bd); }
  .danger:not(:disabled):hover { filter: brightness(1.08); }
}
@media (hover: hover) and (prefers-reduced-motion: no-preference) {
  .btn:not(:disabled):hover svg { animation: lift 300ms cubic-bezier(0.2, 0.8, 0.2, 1) 1; }
}
@keyframes lift { 50% { transform: translateY(-2px); } }

/* ───────── Chip ───────── */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: var(--fw-label);
  white-space: nowrap;
  background: var(--ctl);
  color: var(--tx2);
}
.chip svg { flex-shrink: 0; }
.dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.t-neutral { background: var(--ctl); color: var(--tx2); }
.t-info { background: var(--pri-bg); color: var(--link); }
.t-ok { background: var(--ok-bg); color: var(--ok); }
.t-warn { background: var(--warn-bg); color: var(--warn); }
.t-err { background: var(--err-bg); color: var(--err); }
.chipX {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: -6px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

/* ───────── Ô nhập · select ───────── */
.field { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.label { font-size: 12px; font-weight: var(--fw-label); color: var(--tx2); }
.req { color: var(--err); }
.box {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid var(--bd);
  background: var(--inp);
  color: var(--tx);
  transition: border-color 160ms, box-shadow 160ms;
}
.box.area { height: auto; align-items: flex-start; padding: 10px 12px; }
.area .input { height: auto; resize: vertical; line-height: 1.45; }
.area > svg { margin-top: 2px; }
.box:focus-within { border-color: var(--pri); box-shadow: var(--pri-ring); }
.box.bad { border-color: var(--err-bd); box-shadow: var(--err-ring); }
.box.locked { background: var(--sub); color: var(--lb); }
.box > svg { flex-shrink: 0; color: var(--lb); }
.input,
.select {
  flex-grow: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
}
.input::placeholder { color: var(--lb); }
.select { appearance: none; cursor: pointer; padding-right: 22px; }
.select option { background: var(--card); color: var(--tx); }
.caret { position: absolute; right: 10px; pointer-events: none; }
.hint { font-size: 12px; color: var(--lb); }
.errTx { font-size: 12px; color: var(--err); }
.box :focus-visible { outline: 0; }

/* ───────── Bảng ───────── */
.tableWrap {
  position: relative;
  overflow: auto;
  max-height: 100%;
  border-radius: 16px;
  background: var(--card);
  box-shadow: var(--sh);
  scrollbar-width: thin;
  scrollbar-color: var(--bd) transparent;
}
.table { width: 100%; border-collapse: separate; border-spacing: 0; table-layout: fixed; }
.table th {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 40px;
  padding: 0 12px;
  background: var(--sub);
  color: var(--lb);
  font-size: 12px;
  font-weight: var(--fw-label);
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid var(--bd);
}
.table td {
  height: 48px;
  padding: 0 12px;
  border-bottom: 1px solid var(--line);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dense td { height: 40px; }
.table tr:last-child td { border-bottom: 0; }
.num { text-align: right !important; }
.sel { width: 44px; padding: 0 0 0 4px !important; }
.minor { }
@media (max-width: 767px) {
  th.minor, td.minor { display: none; }
}
.rowOn td { background: var(--pri-bg); }
.clickable { cursor: pointer; }
@media (hover: hover) {
  .table tbody tr:not(.rowOn):hover td { background: var(--sub); }
}
.checkBtn { font: inherit; width: 36px; height: 36px; padding: 0; border: 0; background: transparent; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.checkBtn:focus-visible { outline: 2px solid var(--pri); outline-offset: -2px; border-radius: 8px; }
.checkBox { width: 18px; height: 18px; flex-shrink: 0; box-sizing: border-box; border-radius: 5px; border: 1.5px solid var(--bd); background: var(--card); color: var(--on-color); display: flex; align-items: center; justify-content: center; }
.checkBoxOn { border-color: var(--pri); background: var(--pri); }
.bulk {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 6px 0 16px;
  border-radius: 12px;
  background: var(--pri-bg);
  box-shadow: inset 0 0 0 1px var(--pri-bd);
}
.bulk > b { font-weight: var(--fw-title); color: var(--link); }
.bulkActs { margin-left: auto; display: flex; gap: 6px; }

/* ───────── Lớp nổi: modal · drawer ───────── */
.scrim { position: fixed; inset: 0; z-index: 60; background: var(--scrim); }
.modal {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 61;
  transform: translate(-50%, -50%);
  width: min(520px, calc(100vw - 32px));
  max-height: calc(100dvh - 48px);
  display: flex;
  flex-direction: column;
  border-radius: 18px;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
}
.drawer {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 61;
  width: min(640px, 100vw);
  display: flex;
  flex-direction: column;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
}
.ovHead { display: flex; align-items: center; gap: 10px; min-height: 60px; padding: 0 12px 0 20px; border-bottom: 1px solid var(--line); flex-shrink: 0; }
.ovTitle { flex-grow: 1; margin: 0; font-size: 18px; font-weight: var(--fw-title); }
.ovIcon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--err-bg);
  color: var(--err);
}
.ovBody { flex-grow: 1; min-height: 0; overflow-y: auto; padding: 16px 20px; display: flex; flex-direction: column; gap: 14px; }
.ovDesc { margin: 0; color: var(--tx2); }
.ovFoot { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 20px; border-top: 1px solid var(--line); flex-shrink: 0; }
/* Mint-Motion mục 7: ngăn vào 240 ms out từ phải, nền mờ 180 ms; ra 180 ms in (Radix chờ animation xong mới gỡ) */
@media (prefers-reduced-motion: no-preference) {
  .scrim[data-state='open'], .scrim:not([data-state]) { animation: fade var(--dur-sm) var(--ease-out) both; }
  .scrim[data-state='closed'] { animation: fadeOut var(--dur-sm) var(--ease-in) both; }
  .modal { animation: pop 200ms cubic-bezier(0.16, 1, 0.3, 1); }
  .drawer { animation: slideIn var(--dur-md) var(--ease-out) both; }
  .drawer[data-state='closed'] { animation: slideOut var(--dur-sm) var(--ease-in) both; }
}
@keyframes fade { from { opacity: 0; } }
@keyframes fadeOut { to { opacity: 0; } }
@keyframes pop { from { opacity: 0; transform: translate(-50%, -48%) scale(0.98); } }
@keyframes slideIn { from { transform: var(--slide-from, translateX(100%)); } }
@keyframes slideOut { to { transform: var(--slide-from, translateX(100%)); } }
@media (max-width: 640px) {
  /* điện thoại: drawer thành bảng trượt từ đáy */
  .drawer { top: auto; left: 0; width: 100%; max-height: 92dvh; border-radius: 22px 22px 0 0; }
  .drawer { --slide-from: translateY(100%); }
  .ovFoot { padding-bottom: max(12px, env(safe-area-inset-bottom)); }
}

/* ───────── Toast ───────── */
.toasts {
  position: fixed;
  left: 50%;
  bottom: calc(24px + env(safe-area-inset-bottom));
  z-index: 70;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 32px);
}
.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 6px 6px 6px 12px;
  border: 1px solid var(--bd);
  border-radius: 12px;
  background: var(--card);
  color: var(--tx);
  box-shadow: var(--pop);
  font-weight: var(--fw-label);
}
.toastMark {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ok-dot);
  color: var(--on-color);
}
.toastErr .toastMark { background: var(--badge); }
.toastMsg { min-width: 0; }
/* board: điện thoại đẩy toast lên 104px, trên thanh tab dưới */
@media (max-width: 767px) {
  .toasts { bottom: calc(104px + env(safe-area-inset-bottom)); }
}
@media (prefers-reduced-motion: no-preference) {
  .toast { animation: rise var(--dur-sm) var(--ease-out) both; }
}
@keyframes rise { from { opacity: 0; transform: translateY(16px); } }

/* ───────── Trạng thái màn ───────── */
.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 40px 22px;
}
.stateIc {
  width: 56px;
  height: 56px;
  margin-bottom: 4px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--pri-bg);
  color: var(--pri);
}
.stateIc.err { background: var(--err-bg); color: var(--err); }
.stateIc.lock { background: var(--ctl); color: var(--lb); }
.stateTitle { margin: 0; font-size: 15px; font-weight: var(--fw-title); }
.stateDesc { margin: 0; max-width: 420px; color: var(--lb); }
.stateAct { margin-top: 8px; display: flex; gap: 8px; }
.skel { display: flex; flex-direction: column; gap: 10px; padding: 20px 22px; }
.skRow { display: flex; gap: 10px; }
.sk { height: 12px; border-radius: 4px; background: var(--skel2); }
.skStrong { background: var(--skel); }
@media (prefers-reduced-motion: no-preference) {
  .sk { animation: blink 1.2s ease-in-out infinite; }
}
@keyframes blink { 50% { opacity: 0.55; } }

/* ───────── Nhóm nút (tab trạng thái · mật độ) ───────── */
.seg { display: inline-flex; padding: 4px; border-radius: 12px; background: var(--ctl); }
.segBtn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--tx2);
  font: inherit;
  font-weight: var(--fw-label);
  white-space: nowrap;
  cursor: pointer;
}
.segBtn[aria-selected='true'],
.segBtn[aria-pressed='true'] { background: var(--ctl-on); color: var(--tx); box-shadow: var(--seg-sh); }
.segBadge { min-width: 16px; height: 16px; padding: 0 4px; border-radius: 999px; background: var(--err-bd); color: var(--btn-tx); font-size: 11px; font-weight: 600; line-height: 16px; text-align: center; box-sizing: border-box; }
.segN { font-weight: var(--fw-body); color: var(--lb); }

/* ───────── Thiết bị chạm: vùng chạm ≥ 44px, ô nhập 16px (iOS không tự zoom) ───────── */
@media (pointer: coarse) {
  .btn, .iconOnly { min-height: 44px; }
  .iconOnly { min-width: 44px; }
  .box { height: 44px; }
  .box.area { height: auto; }
  .input, .select { font-size: 16px; }
  .segBtn { height: 44px; }
  .chipX { position: relative; }
  .chipX::after { content: ''; position: absolute; inset: -12px; }
}

@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after { transition: none !important; animation-duration: 0.01ms !important; scroll-behavior: auto !important; }
}

.spacer, .table .spacer td { height: 0; padding: 0; border: 0; }
